import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './currency-pairs-log.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const CurrencyPairsLogDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const currencyPairsLogEntity = useAppSelector(state => state.currencyPairsLog.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="currencyPairsLogDetailsHeading">
          <Translate contentKey="comexApp.currencyPairsLog.detail.title">CurrencyPairsLog</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{currencyPairsLogEntity.id}</dd>
          <dt>
            <span id="rate">
              <Translate contentKey="comexApp.currencyPairsLog.rate">Rate</Translate>
            </span>
          </dt>
          <dd>{currencyPairsLogEntity.rate}</dd>
          <dt>
            <Translate contentKey="comexApp.currencyPairsLog.currencyRates">Currency Rates</Translate>
          </dt>
          <dd>{currencyPairsLogEntity.currencyRates ? currencyPairsLogEntity.currencyRates.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/currency-pairs-log" replace data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/currency-pairs-log/${currencyPairsLogEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CurrencyPairsLogDetail;
